import React, { useContext, useEffect, useState } from 'react';
import { FormElement, DragHandle, FormSelector, FormLabel, ResizeIcon } from "../components/StyledElements";
import { Handle, Position, NodeResizeControl } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';
import swal from "sweetalert2";
import { useAgents } from 'contexts/AgentsContext';
import { getClientWorkflowGraphs } from "../services/workflows";
import { AppContext } from 'contexts/AppContext';

export const WorkflowNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Workflow" description="Execute another workflow" onAdd={() => onAdd(250, 100)} style={style} />
  )
};

export const WorkflowNode = ({ id, data }) => {
  const { workflows, setWorkflows } = useAgents();
  const { selectedClient } = useContext(AppContext);
  const [localData, setLocalData] = useState();
  const [workflowOptions, setWorkflowOptions] = useState([]);
  const [workflowDescriptions, setWorkflowDescriptions] = useState({});
  console.log("!!! WORKFLOWS: ", workflows);

  useEffect(() => {
    console.log("!!! FETCHING data SETS");
    const fetchWorkflows = async () => {
      try {
        const results = await getClientWorkflowGraphs(selectedClient.id);
        if (results.success) {
          console.log("!!! FETCHED Workflows: ", results.workflows);
          setWorkflows(results.workflows);

          const options = results.workflows.map((workflow) => ({
            value: workflow.public_id,
            label: workflow.name,
          }));
          setWorkflowOptions(options);

          const descriptions = {};
          results.workflows.forEach((workflow) => {
            descriptions[workflow.public_id] = workflow.description;
          });
          setWorkflowDescriptions(descriptions);
        } else {
          swal.fire({
            title: "Error fetching workflows",
            text: results.message || "An error occurred while fetching workflows. Please try again later.",
            icon: "error",
            confirmButtonText: "OK"
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchWorkflows();
    }
    // eslint-disable-next-line
  }, [selectedClient]);

  useEffect(() => {
    if (!data) {
      return;
    }
    setLocalData({
      workflow: data.workflow,
    });
  }, [data]);

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <NodeResizeControl style={{ zIndex: 40000 }}>
        <ResizeIcon />
      </NodeResizeControl>
      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <DragHandle />
        <FormLabel label="Workflow" />
        <FormElement>
          <div style={{ width: "100%", fontSize: "14px", color: "var(--main-font-color)", marginBottom: "10px" }}>
            Choose a workflow to execute. The input data will be passed to the workflow and the output of the workflow will be passed to the next node.
        </div>
          <FormSelector
            value={localData?.workflow ?? ""}
            options={workflowOptions}
            onChange={(e) => {
              console.log("!!! WORKFLOW CHANGE: ", e.target.value);
              setLocalData({ ...localData, workflow: e.target.value });
              data.onUpdateData(id, { workflow: e.target.value });
            }}
          />
        </FormElement>
        <div style={{ width: "100%", fontSize: "14px", color: "var(--main-font-color)", marginBottom: "10px" }}>
          {localData?.workflow && workflowDescriptions[localData?.workflow] ? workflowDescriptions[localData.workflow] : "No description available for this workflow."}
        </div>

      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      <Handle type="source" position={Position.Right} style={{ height: "12px", width: "12px" }} id="workflow-input" />
    </div>
  );
};

export default WorkflowNode;
